var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tag',{staticClass:"state",attrs:{"size":"is-large","type":_vm.tagType}},[_vm._v(" "+_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }